import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push as pushAction } from 'react-router-redux';
import { Tab, Nav, NavItem } from 'react-bootstrap';
import {
	get, isEmpty, isEqual, find, concat, map,
} from 'lodash';
import { TabsContext } from '@components/contexts';
import { AssignedOfficersTabPane } from '@components';
import JobActions from '@redux/jobs';
import GlobalsActions from '@redux/globals';
import constants from '@constants';
import queryString from 'query-string';

class Officers extends Component {
	constructor(props) {
		super(props);

		const {
			positionId,
			positionsData,
		} = props;
		const officersData = get(find(positionsData, ['positionId', positionId]), 'officers', []);
		const internalOfficers = get(officersData, 'AssignedOfficers', []);
		const externalOfficers = map(get(officersData, 'ExternalOfficers', []), (officer) => ({
			...officer,
			isExternal : true,
		}));
		const assignedOfficers = concat(internalOfficers, externalOfficers);
		const assignedOfficersIds = map(internalOfficers, 'UserId');

		this.state = {
			assignedOfficers,
			assignedOfficersIds,
		};
	}

	static getDerivedStateFromProps = (nextProps, lastState) => {
		const newState = {};
		const {
			positionId,
			positionsData,
		} = nextProps;
		const applicants = get(find(positionsData, ['positionId', positionId]), 'applicants', []);
		const officersData = get(find(positionsData, ['positionId', positionId]), 'officers', []);
		const internalOfficers = get(officersData, 'AssignedOfficers', []);
		const externalOfficers = map(get(officersData, 'ExternalOfficers', []), (officer) => ({
			...officer,
			isExternal : true,
		}));
		const assignedOfficers = concat(internalOfficers, externalOfficers);
		const assignedOfficersIds = map(internalOfficers, 'UserId');

		if (!isEqual(applicants, lastState.applicants)) newState.applicants = applicants;

		if (!isEqual(assignedOfficers, lastState.assignedOfficers)) newState.assignedOfficers = assignedOfficers;

		if (!isEqual(assignedOfficersIds, lastState.assignedOfficersIds)) newState.assignedOfficersIds = assignedOfficersIds;

		return !isEmpty(newState) ? newState : null;
	}

	shouldComponentUpdate = ({
		positionId,
		isLoadingApplicants,
		isLoadingAssignedOfficers,
		user : { TimeZoneId },
		jobEvent : { StatusId },
	}, {
		applicants,
		assignedOfficers,
		assignedOfficersIds,
	}) => {
		const lastProps = this.props;
		const lastState = this.state;

		return (
			!isEqual(positionId, lastProps.positionId)
			|| !isEqual(TimeZoneId, lastProps.user.TimeZoneId)
			|| !isEqual(StatusId, lastProps.jobEvent.StatusId)
			|| !isEqual(isLoadingApplicants, lastProps.isLoadingApplicants)
			|| !isEqual(isLoadingAssignedOfficers, lastProps.isLoadingAssignedOfficers)
			|| !isEqual(applicants, lastState.applicants)
			|| !isEqual(assignedOfficers, lastState.assignedOfficers)
			|| !isEqual(assignedOfficersIds, lastState.assignedOfficersIds)
		);
	}

	onClickDetails = ({ userId }) => {
		const { jobEvent : { Id }, positionId, push } = this.props;
		push({
			pathname : `/jobs/${Id}/locationDetails`,
			search   : queryString.stringify({ userId, positionId }),
		});
	}

	render() {
		const {
			positionId,
			isLoadingAssignedOfficers,
			jobEvent : { StatusId },
			user : { TimeZoneId },
		} = this.props;
		const {
			assignedOfficers,
		} = this.state;

		const isActiveJob = StatusId === constants.JOB_TYPES.active.type;
		const isCompletedJob = StatusId === constants.JOB_TYPES.completed.type;
		const isActiveOrCompletedJob = isActiveJob || isCompletedJob;

		return (
			<TabsContext.Provider>
				<TabsContext.Consumer>
					{({ activeTab, onTabChange }) => (
						<Tab.Container
							id="job-officers-tabs"
							activeKey={activeTab}
							onSelect={onTabChange}
						>
							<div className="position-officers">
								<div className="position-officers__tabs-wrapper">
									<Nav bsStyle="tabs">
										<NavItem eventKey={0}>
											Assigned Officers
											{' '}
											<span>
												(
												{ assignedOfficers.length }
												)
											</span>
										</NavItem>
									</Nav>
								</div>
								<Tab.Content animation>
									<Tab.Pane eventKey={0}>
										<AssignedOfficersTabPane
											isLoading={isLoadingAssignedOfficers}
											timeZone={TimeZoneId}
											positionId={positionId}
											assignedOfficers={assignedOfficers}
											allowAssign={false}
											isActiveOrCompletedJob={isActiveOrCompletedJob}
											onClickDetails={this.onClickDetails}
										/>
									</Tab.Pane>
								</Tab.Content>
							</div>
						</Tab.Container>
					) }
				</TabsContext.Consumer>
			</TabsContext.Provider>
		);
	}
}

const mapStateToProps = ({
	app : { user },
	jobs : {
		jobEvent,
		positionsData,
		loaders : {
			applicants : isLoadingApplicants,
			officers : isLoadingAssignedOfficers,
		},
	},
}) => ({
	user,
	jobEvent,
	positionsData,
	isLoadingApplicants,
	isLoadingAssignedOfficers,
});

const mapDispatchToProps = (dispatch) => ({
	push         : bindActionCreators(pushAction, dispatch),
	setModalOpen : bindActionCreators(JobActions, dispatch).setModalOpen,
	changeState  : bindActionCreators(GlobalsActions, dispatch).changeState,
});

Officers.propTypes = {
	isLoadingApplicants       : PropTypes.bool,
	isLoadingAssignedOfficers : PropTypes.bool,
	positionId                : PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string,
	]),
	positionsData : PropTypes.array,
	push          : PropTypes.func.isRequired,
	user          : PropTypes.object,
	jobEvent      : PropTypes.object,
};

Officers.defaultProps = {
	isLoadingApplicants       : false,
	isLoadingAssignedOfficers : false,
	positionId                : '',
	positionsData             : [],
	user                      : {},
	jobEvent                  : {},
};

export default connect(mapStateToProps, mapDispatchToProps)(Officers);
